import { Entity } from '@decahedron/entity';

export default class Picture extends Entity {
    public path: string = null;

    public url: string = null;

    public position: number = null;

    get thumb320Url(): string {
        return this.thumbUrl(320);
    }

    get thumb380Url(): string {
        return this.thumbUrl(380);
    }

    protected thumbUrl(size: number): string {
        const index = this.url.lastIndexOf('/');
        return `${this.url.substr(0, index)}/${size}-${this.url.substr(index + 1)}`;
    }
}
